import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TeamSection = () => {
  const teamMembers = [
    {
      name: "Jean-Pierre Mukendi",
      role: "Fondateur & PDG",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10d17e2d1-1763293910418.png",
      imageAlt: "Homme d\'affaires africain professionnel en costume bleu marine avec sourire confiant devant un fond de bureau moderne",
      expertise: ["Leadership Stratégique", "Développement Commercial", "Expansion Marché"],
      bio: "Avec plus de 15 ans d'expérience dans le paysage commercial de la RDC, Jean-Pierre a fondé ORAZEK Investment avec la vision de transformer les normes de prestation de services. Sa compréhension approfondie de la dynamique du marché local combinée à son sens des affaires international a positionné ORAZEK comme le principal fournisseur de solutions dans la région.",
      linkedin: "#",
      email: "jp.mukendi@orazek.com"
    },
    {
      name: "Marie-Claire Kabongo",
      role: "Directrice des Opérations",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce7c97a0-1763299091149.png",
      imageAlt: "Femme d'affaires africaine professionnelle en blazer bordeaux élégant avec sourire chaleureux dans un bureau corporatif moderne",
      expertise: ["Gestion des Opérations", "Optimisation des Processus", "Assurance Qualité"],
      bio: "Marie-Claire apporte 12 ans d'excellence opérationnelle à ORAZEK, assurant une prestation de services sans faille dans les 12 secteurs d'activité. Son engagement envers la qualité et l'efficacité a été instrumental dans l'atteinte de notre taux de fidélisation client de 98% et l'établissement de normes opérationnelles de pointe.",
      linkedin: "#",
      email: "mc.kabongo@orazek.com"
    },
    {
      name: "Patrick Tshisekedi",
      role: "Directeur Immobilier",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bbbefe5e-1763293730922.png",
      imageAlt: "Homme africain professionnel en costume gris anthracite avec lunettes et expression confiante dans un environnement de bureau haut de gamme",
      expertise: ["Gestion Immobilière", "Investissement Immobilier", "Analyse de Marché"],
      bio: "Patrick dirige notre division immobilière avec une connaissance approfondie des marchés immobiliers de Kinshasa et Lubumbashi. Son expertise en immobilier commercial et résidentiel a aidé des centaines de clients à trouver leurs propriétés idéales tout en maximisant les rendements d\'investissement.",
      linkedin: "#",
      email: "p.tshisekedi@orazek.com"
    },
    {
      name: "Sophie Lumingu",
      role: "Responsable Relations Clients",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce7c97a0-1763299091149.png",
      imageAlt: "Femme d\'affaires africaine professionnelle en blazer bleu royal avec sourire amical dans un espace de bureau contemporain avec éclairage naturel",
      expertise: ["Succès Client", "Gestion des Relations", "Excellence de Service"],
      bio: "Le dévouement de Sophie à la satisfaction client a fait d'elle la pierre angulaire de la réputation d'excellence d'ORAZEK. Avec une formation en hôtellerie et gestion d'entreprise, elle garantit que chaque interaction client reflète notre engagement envers une prestation de services premium.",
      linkedin: "#",
      email: "s.lumingu@orazek.com"
    },
    {
      name: "David Mwamba",
      role: "Directeur Technologie",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_14a3645c0-1763296944878.png",
      imageAlt: "Homme africain professionnel en costume noir avec lunettes modernes et attitude confiante dans un environnement de bureau high-tech",
      expertise: ["Infrastructure IT", "Transformation Numérique", "Intégration Systèmes"],
      bio: "David dirige nos initiatives technologiques, garantissant qu'ORAZEK reste à l'avant-garde de l'innovation numérique en RDC. Son expertise en systèmes d'entreprise et solutions cloud nous a permis de fournir des services technologiques de pointe à notre clientèle diversifiée.",
      linkedin: "#",
      email: "d.mwamba@orazek.com"
    },
    {
      name: "Françoise Kalala",
      role: "Contrôleuse Financière",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_126dc0d58-1763300392819.png",
      imageAlt: "Femme d\'affaires africaine professionnelle en blazer vert émeraude avec attitude professionnelle dans un bureau financier moderne",
      expertise: ["Planification Financière", "Gestion des Risques", "Conformité"],
      bio: "Françoise garantit l\'intégrité financière et la conformité réglementaire d\'ORAZEK dans toutes les opérations. Son approche méticuleuse de la gestion financière et sa compréhension approfondie des réglementations commerciales de la RDC offrent à nos clients confiance dans notre gouvernance d\'entreprise.",
      linkedin: "#",
      email: "f.kalala@orazek.com"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' }
    }
  };

  return (
    <section className="py-20 lg:py-28 bg-slate-100 dark:bg-slate-900 border-y border-slate-200 dark:border-white/5 relative overflow-hidden">
      {/* Noise texture overlay */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat',
          backgroundSize: '128px 128px'
        }}
      />
      {/* Radial gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(59,130,246,0.08),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(245,158,11,0.05),transparent_60%)]" />

      <div className="w-full max-w-[1920px] mx-auto px-6 sm:px-12 lg:px-16 relative z-10">
        {/* Section Header */}
        <motion.div
          className="text-center mb-12 lg:mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <div className="inline-flex items-center gap-2 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 px-5 py-2.5 rounded-full mb-6">
            <Icon name="Users" size={18} className="text-amber-400" />
            <span className="text-sm font-medium text-slate-600 dark:text-slate-300">Équipe de Direction</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-slate-900 dark:text-white mb-4">
            Rencontrez les Experts Derrière{' '}
            <span className="bg-gradient-to-r from-blue-400 to-amber-400 bg-clip-text text-transparent">
              ORAZEK
            </span>
          </h2>
          <p className="text-xl text-slate-600 dark:text-slate-400 max-w-3xl mx-auto">
            Notre équipe de direction combine des décennies d'expertise du marché local avec des normes commerciales internationales, stimulant l'excellence dans tous les aspects de nos opérations.
          </p>
        </motion.div>

        {/* Team Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
        >
          {teamMembers?.map((member, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              className="bg-white/80 dark:bg-slate-800/50 rounded-[2rem] overflow-hidden border border-slate-200 dark:border-slate-700 hover:border-blue-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-900/20 group"
            >
              {/* Image Area */}
              <div className="relative h-72 lg:h-80 overflow-hidden">
                <Image
                  src={member?.image}
                  alt={member?.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent" />
                <div className="absolute bottom-4 left-5 right-5">
                  <h3 className="text-xl font-bold text-white mb-1">
                    {member?.name}
                  </h3>
                  <p className="text-sm text-slate-200 dark:text-slate-300">{member?.role}</p>
                </div>
              </div>

              {/* Card Content */}
              <div className="p-6 bg-white/80 dark:bg-slate-800/30">
                <div className="flex flex-wrap gap-2 mb-4">
                  {member?.expertise?.map((skill, skillIndex) => (
                    <span
                      key={skillIndex}
                      className="text-xs px-3 py-1 bg-blue-500/10 text-blue-400 rounded-full"
                    >
                      {skill}
                    </span>
                  ))}
                </div>

                <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed mb-6 line-clamp-4">
                  {member?.bio}
                </p>

                <div className="flex items-center gap-3 pt-4 border-t border-slate-200 dark:border-slate-700/50">
                  <a
                    href={member?.linkedin}
                    className="w-10 h-10 rounded-full bg-white/80 dark:bg-white/5 border border-slate-200 dark:border-white/10 flex items-center justify-center text-blue-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-300"
                  >
                    <Icon name="Linkedin" size={16} />
                  </a>
                  <a
                    href={`mailto:${member?.email}`}
                    className="w-10 h-10 rounded-full bg-white/80 dark:bg-white/5 border border-slate-200 dark:border-white/10 flex items-center justify-center text-blue-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-300"
                  >
                    <Icon name="Mail" size={16} />
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TeamSection;
